module.exports = __webpack_public_path__ + "img/bg3.73b64efb.jpg";